import React from 'react'
import { Item } from 'semantic-ui-react'
// import myExperience from '../data/myExperience.json'
import img1 from '../assets/images/ds60x60.png'
import img2 from '../assets/images/capital_60x60.png'
import img3 from '../assets/images/logo_60x60.png'
import img4 from '../assets/images/19289be.png'
import img5 from '../assets/images/dodec-design.png'
import img6 from '../assets/images/6.png'


const getImg = (n)=>{
  switch(n){
    case '1':
        return img1;
    case '2':
        return img2;
    case '3':
        return img3;
    case '4':
        return img4;
    case '5':
        return img5;
    case '6':
        return img6;
    default:
        return img1;
  }
}

const MyExperienceList = (props)=>(
  props.tab_experience_content.map((v,k)=>(
        <Item key={k}>
          <Item.Image size='tiny' src={getImg(v.image)}/>
          <Item.Content>
            <Item.Header>{v.title}</Item.Header>
            <Item.Meta>{v.company}</Item.Meta>
            <Item.Description>
                {v.description}
            </Item.Description>
            <Item.Extra>{v.period}</Item.Extra>
            {v.website &&
              <Item.Meta>{v.link}: <a rel="noopener noreferrer" target="_blank" href={v.website}>{v.website}</a></Item.Meta>
            }
          </Item.Content>
        </Item>
  ))
)

const TabExperienceContent = (props) => (
  <div className="tab-Experience-content">
    <Item.Group>
        <MyExperienceList  {...props}/>
    </Item.Group>
  </div>
)

export default TabExperienceContent


// WEBPACK FOOTER //
// ./src/components/TabExperienceContent.js